import React, { Component, ReactNode } from "react";
/// <reference path="src/typings/index.d.ts" />
import { localize } from "src/l10n";
import PhotoBox from "src/ui/components/PhotoBox/PhotoBox";
import "./SocialImagePost.scss";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";

interface IProps {
    post: Spintr.ISocialImagePost;
    parentPost: Spintr.ISocialPostBase;
}

interface IState {
    displayPhotoBox?: boolean;
    photoBoxSrc?: string;
    photoBoxImageId?: number;
}

// Four tiles at most; with more images the last tile says "+n" and opens the viewer at the next image
const maxTiles = 4;

class SocialImagePost extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {};
    }

    public render() : ReactNode {
        const photos = this.props.post.photos || [];
        const imageCount = photos.length;
        const stageClass = " count" + Math.min(imageCount, maxTiles);

        return(
            <div className="SocialImagePost">
                <div className={"image-stage" + stageClass}>
                    {photos.slice(0, maxTiles).map((image, index) => this.renderImage(image, index))}
                </div>
                {
                    this.state.displayPhotoBox && (
                        <PhotoBox
                            imageUrl={this.state.photoBoxSrc}
                            id={this.state.photoBoxImageId}
                            samePostOnly={true}
                            post={this.props.parentPost}
                            onClose={() => {
                                this.setState({
                                    displayPhotoBox: false,
                                    photoBoxSrc: null,
                                    photoBoxImageId: null
                                });
                            }}
                        />
                    )
                }
            </div>
        );
    }

    protected openPhotoBox(image: Spintr.ISocialImageObject): void {
        this.setState({
            displayPhotoBox: true,
            photoBoxImageId: image.id,
            photoBoxSrc: image.photoUrl
        });
    }

    protected renderImage(
        image: Spintr.ISocialImageObject,
        index: number,
        fromInstagram: boolean = false,
    ): ReactNode {
        const photos = this.props.post.photos || [];
        const hiddenCount = photos.length - maxTiles;
        const displayPlus = index === maxTiles - 1 && hiddenCount > 0;
        const classNames = ["image"];

        if (displayPlus) {
            classNames.push("more");
        }

        // "+n" opens the viewer at the first image that isn't shown
        const target = displayPlus ? photos[maxTiles] : image;
        const moreLabel = hiddenCount === 1 ?
            localize("Visa1BildTill") :
            localize("VisaNBilderTill").replace("{0}", hiddenCount.toString());

        return (
            <button
                type="button"
                className={classNames.join(" ")}
                key={"image-post-item"+image.id}
                aria-label={displayPlus ? moreLabel : image.description || undefined}
                onClick={() => this.openPhotoBox(target)}
            >
                {!displayPlus &&
                    <div className="maximize-icon">
                        <Visage2Icon icon="maximize-3" color="white" size="small" />
                    </div>}
                <img
                    alt={displayPlus ? "" : image.description}
                    id={"image-post-item"+image.id}
                    data-id={image.id}
                    src={image.photoUrl}
                />
                {displayPlus && (
                    <div className="count" aria-hidden="true">
                        {"+" + hiddenCount}
                    </div>
                )}
                {fromInstagram && (
                    <div className="instagram-icon" />
                )}
            </button>
        );
    }
}

export default SocialImagePost;
